export class ResetPasswordRequest {
  email: string;
  method: string;
}
